// extracted by mini-css-extract-plugin
export default {"list--logos":"indexAr_list--logos__R8EOz","list_item":"indexAr_list_item__0ouGy","border":"indexAr_border__sx6We","ul":"indexAr_ul__8kPW8","m_bottom":"indexAr_m_bottom__AbCav"};